import style from './dedicated-development-teams-section.module.scss';
import template from '@components/services/services.module.scss';
import Image from 'next/image';

interface IDedicatedDevelopmentTeamsSection {
  imageSrc: string;
  title: string;
  text: string[];
}

const DedicatedDevelopmentTeamsSection = ({ imageSrc, title, text }: IDedicatedDevelopmentTeamsSection) => {
  return (
    <section className={`${template.section} ${style.section}`}>
      <div
        className={`${template.container} ${style.container__wrapper} ${template.container_large} ${template.flex} ${template.flex_justify_content_space_between}`}
      >
        <div className={`${style.textblock}`}>
          <div
            className={`${template.title} ${template.title_large} ${template.text_align_l} ${template.mb20} ${style.textblock__header}`}
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
          <div className={`${style.textblock__content}`}>
            {text.map((item: string, index: number) => {
              return (
                <div
                  key={index}
                  className={`${template.text} ${template.text_small} ${template.text_color_main} ${template.text_align_l} ${style.textblock__content__text} ${template.mb16} ${template.fw400}`}
                  dangerouslySetInnerHTML={{ __html: item }}
                ></div>
              );
            })}
          </div>
        </div>
        <div className={`${template.image} ${template.image_medium} ${style.image}`}>
          <Image src={imageSrc} alt={title} layout={'fill'} />
        </div>
      </div>
    </section>
  );
};

export default DedicatedDevelopmentTeamsSection;
